/**
 * the up and down arrows to reorder states
 * @param {Object} params
 * @param {() => void} params.onStateMove callback to handle state reordering
 * @param {boolean} params.isFirstState
 * @param {boolean} params.isLastState
 * @returns {JQuery<HTMLElement>}
 */
export const reorderControls = ({onStateMove, isFirstState, isLastState}) => {
  const lArrowUpIcon = $('<div>')
    .addClass('ml_fsm_reorder_arrow_base ml_fsm_reorder_arrow_up');

  const lArrowDownIcon = $('<div>')
    .addClass('ml_fsm_reorder_arrow_base ml_fsm_reorder_arrow_down');

  const lArrowUpButton = $('<div>')
    .addClass('ml_fsm_reorder_button')
    .on('click', () => onStateMove('up'))
    .append(lArrowUpIcon)
    .css({
      visibility: isFirstState ? 'hidden' : 'visible',
    });

  const lArrowDownButton = $('<div>')
    .addClass('ml_fsm_reorder_button')
    .on('click', () => onStateMove('down'))
    .append(lArrowDownIcon)
    .css({
      visibility: isLastState ? 'hidden' : 'visible',
    });

  return $('<div>')
    .css({
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column'
    })
    .append(
      lArrowUpButton,
      lArrowDownButton
    );
};
